import { useId } from 'react'
import { Loader2, Play } from 'lucide-react'

import { Button } from 'components/ui/button'

/**
 * Confirm, and why not (MYD-623).
 *
 * A disabled button cannot show a hover tooltip to a keyboard user, and
 * cannot be focused to find one. So the reason it is disabled is a line of
 * text beside it, tied to it with aria-describedby, and the button's title
 * repeats it for the mouse.
 */

export interface ExecuteBarProps {
	/** Why Confirm may not be pressed, or null when it may. */
	blocker: string | null
	executing: boolean
	stepCount: number
	onConfirm: () => void
}

export function ExecuteBar({ blocker, executing, stepCount, onConfirm }: ExecuteBarProps) {
	const reasonId = useId()
	return (
		<div className="flex flex-wrap items-center justify-end gap-x-3 gap-y-1 border-t border-gray-100 pt-3">
			{blocker && (
				<p id={reasonId} className="min-w-0 flex-1 text-xs text-muted-foreground">
					{blocker}
				</p>
			)}
			<Button onClick={onConfirm} disabled={Boolean(blocker) || executing} aria-describedby={blocker ? reasonId : undefined} title={blocker ?? undefined}>
				{executing ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Play className="mr-1.5 h-3.5 w-3.5" />}
				{executing ? 'Running…' : stepCount === 1 ? 'Confirm and run 1 step' : `Confirm and run ${stepCount} steps`}
			</Button>
		</div>
	)
}

export default ExecuteBar
